import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { queryCache, QueryConfig, useQuery } from 'react-query';

import { __DEV__ } from '~src/config';
import { TenderCoreRegVM } from '~src/types/db';
import { loadTendersRegistrationCoreTenders } from '~src/services/api';

import { useProjectId } from '../useProjectId';
import { loadTenderShareCoreRegistration } from '~src/services/api/shares';

export const useRegistrationCoreTendersDetails = (
  data: {
    tenderId: string | undefined;
    isShares?: {
      shareId: string;
      shareKey: string;
    };
  },
  queryConfig: QueryConfig<TenderCoreRegVM, AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();

  useEffect(() => {
    queryCache.invalidateQueries('tendersRegistrationCoreTenders');
    queryCache.invalidateQueries('sharesTendersRegistrationCoreTenders');
  }, [data.tenderId, projectId, data.isShares]);

  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderDetails = useQuery<TenderCoreRegVM, AxiosError>(
    ['tendersRegistrationCoreTenders', { projectId, tenderId: data.tenderId }],
    loadTendersRegistrationCoreTenders,
    {
      enabled: enabledOverwrite && projectId && data.tenderId && !data.isShares,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  const shareTenderDetails = useQuery<TenderCoreRegVM, AxiosError>(
    [
      'sharesTendersRegistrationCoreTenders',
      { id: data.isShares?.shareId, key: data.isShares?.shareKey },
    ],
    loadTenderShareCoreRegistration,
    {
      enabled: enabledOverwrite && data.isShares,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return data.isShares ? shareTenderDetails.data : tenderDetails.data;
};
